import React from "react";

import { TextField, Table, TableCell, Modal, TableBody, Radio, TableHead, TableContainer,  TableRow, Button, Box, Tooltip, Paper, Toolbar, Typography, IconButton  } from '@material-ui/core';


const CommonTable = (props) => {
  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: "100%", fontWeight: "Lato" }} aria-label="customized table">
          <TableHead>
            <TableRow style={{ backgroundColor: "#dfeacd"}}>
              <TableCell style={style}><b style={{color: "#000"}}>Plan Fees</b></TableCell>
              <TableCell style={style} align="left">
              <b style={{color: "#000"}}>Here's your first payment</b>
              </TableCell>
              <TableCell style={style} align="left">
              <b style={{color: "#000"}}>Here's your subsequent <br />
                monthly payment</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow style={{ borderBottom : '1.5px solid #23436c',}}>
              <TableCell style={style} component="th" scope="row">
              <p style={{color: "#000", marginBottom: 0}}>Monthly Payment for <b>{props.planSelected.planId}</b> ({props.selectedFamily})</p>
              </TableCell>
              <TableCell style={style} component="th" scope="row" align="left">
              <p style={{color: "#000", marginBottom: 0}}>${Number(props.costSelected).toFixed(2)}</p>
              </TableCell>
              <TableCell style={style} align="left">
              <p style={{color: "#000", marginBottom: 0}}>${Number(props.costSelected).toFixed(2)}</p>
              </TableCell>
            </TableRow>
            <TableRow  style={{ borderBottom : '1.5px solid #23436c',}}>
              <TableCell style={style} component="th" scope="row">
              <p style={{color: "#000", marginBottom: 0}}>One Time Enrollment Fee</p>
              </TableCell>
              <TableCell style={style} component="th" scope="row" align="left">
              <p style={{color: "#000", marginBottom: 0}}>${Number(props.enrollFeeSelected).toFixed(2)}</p>
              </TableCell>
              <TableCell style={style} align="left">-</TableCell>
            </TableRow>

            <TableRow style={{background: "#b31b44", borderBottom : '1.5px solid #23436c'}}>
              <TableCell style={style}><b style={{color: "#fff"}}>Family Total</b></TableCell>
              <TableCell style={style} align="left">
              <b style={{color: "#fff"}}>${Number(props.costSelected + props.enrollFeeSelected).toFixed(2)}</b>
              </TableCell>
              <TableCell style={style} align="left">
              <b style={{color: "#fff"}}>${Number(props.costSelected).toFixed(2)}</b>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
export default CommonTable;

const style={
  padding: 11
}